import { NAV, CONTACT_EMAIL } from "@/lib/content";
import { scrollToId, useWhatsApp } from "@/lib/site";
import { Logo } from "@/components/Logo";

export default function Footer() {
  const whatsapp = useWhatsApp();
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-ink text-white">
      <div className="wrap grid grid-cols-1 gap-10 py-14 lg:grid-cols-12 lg:items-start">
        <div className="flex flex-col gap-3 lg:col-span-4">
          <Logo size={30} onDark />
          <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/50">www.faizu.net</span>
        </div>
        <nav aria-label="Footer" className="lg:col-span-4">
          <ul className="flex flex-wrap gap-x-6 gap-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <a
                  href={`#${n.id}`}
                  onClick={(e) => { e.preventDefault(); scrollToId(n.id); }}
                  data-testid={`footer-link-${n.id}`}
                  className="text-[14px] text-white/60 transition-colors duration-200 hover:text-white"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div className="flex flex-col gap-2 text-[14px] lg:col-span-4 lg:items-end">
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link" className="whitespace-nowrap text-white/80 transition-colors duration-200 hover:text-emerald-dot">
            {CONTACT_EMAIL}
          </a>
          {whatsapp && (
            <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="text-white/80 transition-colors duration-200 hover:text-emerald-dot">
              Chat on WhatsApp
            </a>
          )}
        </div>
      </div>
      <div className="wrap border-t border-white/10 py-6 text-[13px] text-white/45">© {new Date().getFullYear()} FAIZ</div>
    </footer>
  );
}
